"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const AssignmentsContext_1 = require("./AssignmentsContext");
const AssignmentsReducer_1 = __importDefault(require("./AssignmentsReducer"));
function AssignmentProvider(props) {
    const { children } = props;
    const { data: spectra } = (0, ChartContext_1.useChartData)();
    const [data, dispatch] = (0, react_1.useReducer)(AssignmentsReducer_1.default, AssignmentsContext_1.assignmentState);
    const state = (0, react_1.useMemo)(() => ({ data, dispatch }), [data]);
    (0, react_1.useEffect)(() => {
        if (spectra) {
            dispatch({
                type: 'INITIATE_ASSIGNMENTS',
                // TODO: Fix this type error. It's been here for a long time because this component wasn't typed.
                // @ts-expect-error This should be fixed.
                payload: { spectra },
            });
        }
    }, [spectra]);
    return ((0, jsx_runtime_1.jsx)(AssignmentsContext_1.assignmentContext.Provider, { value: state, children: children }));
}
exports.AssignmentProvider = AssignmentProvider;
